import ExamsModel from '../Apis/Exams'
import Controller from './Controller'
import Swal from 'sweetalert2'

export default class ExamsController extends Controller {
  constructor() {
    super(new ExamsModel())
  }
  async getQuestions(id) {
    const response = await this.model.getQuestions(id)
    return response
  }
  async getEduCourseProgramsExams(params) {
    const response = await this.model.getEduCourseProgramsExams(params)
    return response
  }
 
  async addNewQuestion(params) {
    const res = await this.model.addNewQuestion(params);
    return this.Poup(res);

  }
}
